import Vue from 'vue'
import Vuex from 'vuex'
import SignIn from '../SignIn/store'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		authenticated: false,
		pendingRequests: 0
	},
	mutations: {
		beginRequest(state) {
			state.pendingRequests++;
		},
		endRequest(state) {
			if (state.pendingRequests > 0) {
				state.pendingRequests--;
			}
		}
	},
    modules: {
		SignIn
    }
});
